module.exports = __webpack_public_path__ + "static/img/GB.001a8a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/countryFlag/GB.svg
// module id = GigF
// module chunks = 55